import { Grid, IconButton } from '@mui/material';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Bin from '../../../../Components/Icons/Bin';
import EditIcon from "../../../../Components/Icons/EditIcon";

class QuestionListItem extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <div style={{ padding: '15px', backgroundColor: 'var(--ui-background)', borderRadius: '4px', border: '1px solid var(--ui-line-break)'}}>
                <Grid container>
                    <Grid sx={{ alignContent: 'center' }} item xs={2}>
                        <IconButton className='mr-2' onClick={() => this.props.onArrowUp()}><KeyboardArrowUpIcon /></IconButton>
                        <IconButton className='mr-2' onClick={() => this.props.onArrowDown()}><KeyboardArrowDownIcon /></IconButton>
                    </Grid>
                    <Grid sx={{ alignContent: 'center' }} item xs={4}>
                        {this.props.name}
                    </Grid>
                    <Grid sx={{ alignContent: 'center' }} item xs={3}>
                        {this.props.type}
                    </Grid>
                    <Grid sx={{ alignContent: 'center', textAlign: 'right' }} item xs={3}>
                        <IconButton className='mr-2' onClick={() => this.props.onDelete()}><Bin /></IconButton>
                        <IconButton className="mr-2" onClick={() => this.props.onEdit()}><EditIcon /></IconButton>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default QuestionListItem;

export interface IProps
{
    onArrowUp: () => void;
    onArrowDown: () => void;
    name: string;
    type: string;
    onEdit: () => void;
    onDelete: () => void;
}

export interface IState
{
}